import { b as __rest, a as __assign } from '../../tslib.es6-a39f91fc.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { c as classNames } from '../../index-6ea95111.js';
import React__default from 'react';

var buttonTypeClassNameMap = {
    filledColor: 'p-btn--primary',
    filledGray: 'p-btn--secondary-grey',
    filledWhite: 'p-btn--secondary-white',
    filledBlack: 'p-btn--secondary-black',
    textColor: 'p-btn--secondary',
    textWhite: 'p-btn--secondary-inverted',
    outlineWhite: 'p-btn--outline-white',
    filledSuccess: 'p-btn--success',
    filledError: 'p-btn--danger',
};
var buttonDefaultAsType = 'button';
var Button = React__default.forwardRef(function (_a, ref) {
    var _b = _a.as, ButtonTag = _b === void 0 ? buttonDefaultAsType : _b, className = _a.className, _c = _a.loading, loading = _c === void 0 ? false : _c, children = _a.children, _d = _a.variant, variant = _d === void 0 ? 'filledColor' : _d, leftIcon = _a.leftIcon, rightIcon = _a.rightIcon, hideLabel = _a.hideLabel, props = __rest(_a, ["as", "className", "loading", "children", "variant", "leftIcon", "rightIcon", "hideLabel"]);
    return (jsx(ButtonTag, __assign({ ref: ref, className: classNames(buttonTypeClassNameMap[variant], className, {
            'p-btn--loading': loading,
            'tc-transparent': loading,
            'p-btn--icon-only': hideLabel,
        }), "data-testid": "button" }, props, { children: !loading && (leftIcon || rightIcon) ? (jsxs("div", { className: "d-flex jc-center ai-center", children: [leftIcon && (jsx("span", { className: classNames('d-inline-flex', {
                        'mr8': !hideLabel
                    }), children: React__default.cloneElement(leftIcon, {
                        size: 20,
                        noMargin: true
                    }) })), jsx("div", { className: classNames({
                        'sr-only': hideLabel
                    }), children: children }), rightIcon && (jsx("span", { className: classNames('d-inline-flex', {
                        'ml8': !hideLabel
                    }), children: React__default.cloneElement(rightIcon, {
                        size: 20,
                        noMargin: true
                    }) }))] })) : children })));
});

export { Button };
//# sourceMappingURL=index.js.map
